<template>
  <section class="notFound">
    <img class="logo" src="@/assets/landing-credit-info/logo-s.svg" alt="logo">

    <div class="number-404">
      <div class="item">
        <p class="number number-one">{{ errorCodeArray[0] }}</p>
        <p class="number grey">{{ errorCodeArray[0] }}</p>
      </div>
      <div class="item">
        <p class="number number-two">{{ errorCodeArray[1] }}</p>
        <p class="number grey">{{ errorCodeArray[1] }}</p>
      </div>
      <div class="item">
        <p class="number">{{ errorCodeArray[2] }}</p>
      </div>
    </div>

    <h1 class="fn-title-1">
      Ви не повинні бути тут
    </h1>

    <p class="m-body-m">
      Перейдіть на головну сторінку
    </p>

    <button class="medium-btn main-btn second-color" @click="$router.push('/')">На головну сторінку</button>
  </section>
</template>

<script>
export default {
  props: {
    errorCode: {
      type: Number,
      default: 404
    }
  },
  computed: {
    errorCodeArray: function () {
      return Array.from(String(this.errorCode), Number)
    }
  }
}
</script>

<style lang="less" scoped>
.notFound {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .number {
    font-size: 200px;
    color: #9ADBE8;
    font-weight: 900;
    line-height: 154px;
  }

  .grey {
    color: #F9FBFD;
  }

  .logo {
    position: absolute;
    top: 48px;
    left: 48px;
    width: 103px;
  }

  .number-404 {
    display: flex;
    margin: 0 0 43px 0;

    .item {
      position: relative;
    }

    .number-one {
      position: absolute;
      left: 0;
      animation: first-animation linear 16s infinite;
    }

    .number-two {
      position: absolute;
      left: 0;
      animation: two-animation ease-in-out 16s infinite;
    }
  }

  @keyframes first-animation {
    0% { transform: translate(0, 0) rotate(0) }
    17% { transform: translate(0, 0) rotate(0) }
    18% { transform: translate(-62px, 58px) rotate(-68deg) }
    98% { transform: translate(-62px, 58px) rotate(-68deg) }
    99% { transform: translate(-66px, 59px) rotate(-69deg) }
    100% { transform: translate(0, 0) rotate(0) }
  }

  @keyframes two-animation {
    0% { transform: translate(0, 0) rotate(0) }
    20% { transform: translate(0, 0) rotate(0) }
    21% { transform: translate(0, 57px) rotate(12deg) }
    45% { transform: translate(10px, 57px) rotate(30deg) }
    90% { transform: translate(-55px, 57px) rotate(-20deg) }
    98% { transform: translate(-50px, 57px) rotate(-20deg) }
    99% { transform: translate(-50px, 57px) rotate(-21deg) }
    100% { transform: translate(0, 0px) rotate(12deg) }
  }

  h1 {
    margin: 0 0 12px 0;
    padding: 0;
    color: var(--main-base);
  }

  p {
    margin: 0 0 48px 0;
  }
}
</style>
